import CONSTANT from "../../constants/Constant";
import React, {Fragment} from "react";
import InputBox from "../shared/form-element/InputBox";
import RadioButton from "../shared/form-element/RadioButton";
import { isMobile } from "react-device-detect";
import MaskInput from "../shared/form-element/MaskInput";
import DropdownItem from "../shared/form-element/DropdownItem";
import { useSelector } from "react-redux";
import { deepClone, getMarkup } from "../../utils/Utils";
import { getIndexOfCurrentGroup } from "./EditAssessmentUtils";
import useEditAssessmentBody from "./hooks/useEditAssessmentBody";
import ChiefComplaint from "../shared/chiefComplaintNew/ChiefComplaint";
import CheckboxForEditAssessment from "../shared/form-element/CheckboxForEditAssessment";
import './EditAssessmentQuestionContainer.scss';

const EditAssessmentQuestionContainer = ({ setSelectedElementForScroll }) => {
    const editAssessmentGroup = useSelector(state => state.editAssessment);

    const { handleAnswerSave, handleUpdateCCQuestionAnswer, willShowCurrentQuestion, getDropDownOptions } = useEditAssessmentBody(setSelectedElementForScroll);

    const groups = editAssessmentGroup?.groups;

    const baseData = editAssessmentGroup?.baseData || {};
    const ccQuestion = editAssessmentGroup?.ccQuestion || {};
    const currentGroupId = baseData?.currentGroupId || CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key;
    const currentGroupIndex = getIndexOfCurrentGroup(groups, currentGroupId);
    const currentSubGroupIndex = baseData?.currentSubGroupIndex || 0;
    const testId = baseData?.testId || "";
    const isReportAvailable = baseData?.isReportAvailable || false;
    const showInlineError = baseData?.showInlineError || false;
    const currentQuestionId = baseData?.currentQuestionId || false;
    const isBlocked = baseData?.isBlocked || false;
    const exitWorkflowMessage = baseData?.exitWorkflowMessage || "";

    const currentGroup = groups[currentGroupIndex];

    return (
        <Fragment>
            {isBlocked && (
                <div className="mmh-callout mmh-callout--danger margin-bottom-1-rem">
                    <div className="mmh-callout__body">
                        <div className="mmh-callout__content">
                            <h3 className="mmh-callout__title">Pre-Assessment Functional Questionnaire</h3>
                            <div className="mmh-callout__desc">
                                <span className="mmh-font-xl" dangerouslySetInnerHTML={getMarkup(exitWorkflowMessage)}>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {currentGroupId === CONSTANT.ASSESSMENT_GROUP.CHIEF_COMPLAINTS.key &&
                (
                    <div className={`edit-assessment-question-container__chief-complaint-container edit-assessment-question-container__center edit-assessment-question-container--w-100 `}>
                        <ChiefComplaint
                            testId={testId}
                            isReportAvailable={isReportAvailable}
                            ccQuestion={ccQuestion}
                            updateAnswer={handleUpdateCCQuestionAnswer}
                        />
                    </div>
                )
            }

            {currentGroup?.subGroups.map((subGroup, index) => {
                if(
                    (
                        (index === currentSubGroupIndex) &&
                        (currentGroupId !== CONSTANT.ASSESSMENT_GROUP.CHIEF_COMPLAINTS.key)
                    ) ||
                    (currentGroupId === CONSTANT.ASSESSMENT_GROUP.OUTCOME_ASSESSMENT.key)
                ) {
                    return (
                        <>
                            <div className={`edit-assessment-question-container__subgroup`}>{subGroup?.header1}</div>

                            {subGroup?.pageCaption && (
                                <div
                                    className="edit-assessment-question-container__page-caption">{subGroup?.pageCaption}
                                </div>
                            )}

                            <div
                                className="edit-assessment-question-container__question-group edit-assessment-question-container--mb-0 edit-assessment-question-container--pb-0 edit-assessment-question-container--mt-10"
                                data-state="current"
                            >
                                {subGroup?.questions.map((question) => {
                                    return (
                                        <Fragment
                                            key={question?.questionId}>
                                            {(((currentGroupId !== CONSTANT.ASSESSMENT_GROUP.CHIEF_COMPLAINTS.key)) && willShowCurrentQuestion(question)) &&
                                                (
                                                    <>
                                                        {(question.responseType === CONSTANT.ELEMENT_TYPES.TEXT
                                                                || question.responseType === CONSTANT.ELEMENT_TYPES.CALCULATION
                                                                || question.responseType === CONSTANT.ELEMENT_TYPES.NUMBER) &&
                                                            question.questionId !== CONSTANT.CHATBOT_ACCOUNT.DATE_OF_BIRTH &&
                                                            question.questionId !== CONSTANT.CHATBOT_ACCOUNT.NEXT_KEY_EVENT_DATE && (
                                                                <InputBox
                                                                    disabled={question.isScoreQuestion || isReportAvailable}
                                                                    label={question.text}
                                                                    placeHolder={question.dialogue}
                                                                    value={question.answerValue}
                                                                    question={question}
                                                                    error={showInlineError && question.error?.message && question.error}
                                                                    onChange={handleAnswerSave}
                                                                />
                                                        )}
                                                        {question.responseType === CONSTANT.ELEMENT_TYPES.BUTTON && question.responses && question.responses.length > 0 && (
                                                            <RadioButton
                                                                disabled={isReportAvailable}
                                                                isFocused={question.questionId === currentQuestionId}
                                                                label={question.text}
                                                                question={question}
                                                                options={question.responses}
                                                                checkedOption={question?.answerId}
                                                                onChange={handleAnswerSave}
                                                                error={showInlineError && question.error?.message && question.error}
                                                                cssStyle={currentGroupId === CONSTANT.ASSESSMENT_GROUP.CHIEF_COMPLAINTS.key || isMobile ? 'column' : 'row'}/>
                                                        )}

                                                        {((question.responseType === CONSTANT.ELEMENT_TYPES.CHECKBOX || question.responseType === CONSTANT.ELEMENT_TYPES.MULTISELECT) &&
                                                            question.responses && question.responses.length > 0) && (
                                                            <CheckboxForEditAssessment
                                                                disabled={isReportAvailable}
                                                                label={question.text}
                                                                question={question}
                                                                options={getDropDownOptions(question)}
                                                                onChange={handleAnswerSave}
                                                                checkedOptionsIds={question?.answerList ? question.answerList : []}
                                                                error={showInlineError && question.error?.message && question.error}
                                                                cssStyle={currentGroupId === CONSTANT.ASSESSMENT_GROUP.CHIEF_COMPLAINTS.key || isMobile ? 'column' : 'row'}/>
                                                        )}
                                                        {((question.responseType === CONSTANT.ELEMENT_TYPES.TEXT && (question.questionId === CONSTANT.CHATBOT_ACCOUNT.DATE_OF_BIRTH || question.questionId === CONSTANT.CHATBOT_ACCOUNT.NEXT_KEY_EVENT_DATE))
                                                            || question.responseType === CONSTANT.ELEMENT_TYPES.DATE_PICKER) && (
                                                            <MaskInput
                                                                disabled={isReportAvailable}
                                                                label={question.text}
                                                                value={question.answerValue}
                                                                placeHolder={question.dialogue}
                                                                question={question}
                                                                mask={(question.questionId === CONSTANT.CHATBOT_ACCOUNT.DATE_OF_BIRTH || question.questionId === CONSTANT.CHATBOT_ACCOUNT.NEXT_KEY_EVENT_DATE || question.responseType === CONSTANT.ELEMENT_TYPES.DATE_PICKER) ? '99/99/9999' : '99/99/9999'}
                                                                error={showInlineError && question.error?.message && question.error}
                                                                onChange={handleAnswerSave}
                                                            />
                                                        )}
                                                        {question.responseType === CONSTANT.ELEMENT_TYPES.DROPDOWN && (
                                                            <DropdownItem
                                                                label={question.text}
                                                                disabled={isReportAvailable}
                                                                checkedOption={question.answerId}
                                                                // value={deepClone(question.responses)}
                                                                value={deepClone(getDropDownOptions(question))}
                                                                question={question}
                                                                mask={(question.questionId === CONSTANT.CHATBOT_ACCOUNT.DATE_OF_BIRTH || question.responseType === CONSTANT.ELEMENT_TYPES.DATE_PICKER) ? '99/99/9999' : '99/99/9999'}
                                                                error={showInlineError && question.error?.message && question.error}
                                                                onChange={handleAnswerSave}
                                                            />
                                                        )}
                                                    </>
                                                )}
                                        </Fragment>
                                    )
                                })}
                            </div>
                        </>
                    )
                }
            })}
        </Fragment>
    )
}

export default EditAssessmentQuestionContainer;
